import React from 'react';
import s from './PlanForm.module.scss';

const PlanCreateForm = ({
  newPlan,
  newSchedules,
  onChange,
  onSubmit,
  onAddInclude,
  onIncludeChange,
  onRemoveInclude,
  onScheduleChange,
  onAddSchedule,
  onCancel,
}) => {
  return (
    <form onSubmit={onSubmit} className={s.root}>
      <div className={s.formRow}>
        <label>
          プラン名:
          <input
            type="text"
            name="campaign"
            value={newPlan.campaign}
            onChange={onChange}
            required
          />
        </label>
        <label>
          所要時間:
          <input
            type="text"
            name="duration"
            value={newPlan.duration}
            onChange={onChange}
            required
          />
        </label>
        <label>
          空港送迎:
          <input
            type="checkbox"
            name="transfer"
            checked={newPlan.transfer}
            onChange={onChange}
          />
        </label>
        <label>
          日本語ガイド:
          <input
            type="checkbox"
            name="japanese_guide"
            checked={newPlan.japanese_guide}
            onChange={onChange}
          />
        </label>
        <select
          name="availability"
          value={newPlan.availability}
          onChange={onChange}
        >
          <option value="毎日">毎日</option>
          <option value="平日">平日</option>
          <option value="土日祝">土日祝</option>
        </select>
      </div>
      <div className={s.formRow}>
        <label>
          大人料金:
          <input
            type="number"
            name="ad_price"
            value={newPlan.ad_price}
            onChange={onChange}
            required
          />
        </label>
        <label>
          子供料金:
          <input
            type="number"
            name="ch_price"
            value={newPlan.ch_price}
            onChange={onChange}
            required
          />
        </label>
        <label>
          家族料金:
          <input
            type="number"
            name="family_price"
            value={newPlan.family_price}
            onChange={onChange}
            required
          />
        </label>
      </div>
      <div className={s.formRow}>
        <label>含まれるもの:</label>
        {newPlan.includes.map((include, index) => (
          <div key={index} className={s.includeItem}>
            <input
              type="text"
              value={include}
              onChange={(e) => onIncludeChange(index, e.target.value)}
              placeholder="例: 昼食"
            />
            <button type="button" onClick={() => onRemoveInclude(index)}>
              削除
            </button>
          </div>
        ))}
        <button type="button" onClick={onAddInclude}>
          + 追加
        </button>
      </div>
      <div className={s.schedule}>
        <button type="button" onClick={onAddSchedule}>
          スケジュールを追加
        </button>
      </div>
      <div className={s.formRow}>
        <h3>スケジュール</h3>
        <table>
          <thead>
            <tr>
              <th>時間</th>
              <th>イベント</th>
              <th>メモ</th>
            </tr>
          </thead>
          <tbody>
  {(newSchedules || []).map((schedule, index) => (
    <tr key={index}>
      <td>
        <input
          type="text"
          name="time"
          value={schedule.time}
          onChange={(e) => onScheduleChange(index, e)}
          className={s.time}
        />
      </td>
      <td>
        <input
          type="text"
          name="event"
          value={schedule.event}
          onChange={(e) => onScheduleChange(index, e)}
          className={s.event}
        />
      </td>
      <td>
        <textarea
          name="notes"
          value={schedule.notes}
          onChange={(e) => onScheduleChange(index, e)}
          className={s.notes}
        />
      </td>
    </tr>
  ))}
</tbody>
        </table>
      </div>
      <div className={s.planAddButton}>
        <button type="submit">プランを作成</button>
        <button type="button" onClick={onCancel}>キャンセル</button>
      </div>
    </form>
  );
};

export default PlanCreateForm;
